import styles from "../pages/exams/myExamPage/examAttemptsPage/ExamAttemptsPage.module.css";
import i18n from "../i18n";
import {toStatusText} from "./statusText";

export const renderAttemptStatusBadge = (attemptStatus, status) => {
    const finalStatus = status === "DISQUALIFIED" ? "DISQUALIFIED" : attemptStatus;
    if (!finalStatus) return "-";

    const normalized = String(finalStatus).toUpperCase();
    let className = styles.attemptStatusDefault;

    if (normalized === "CONFIRMED" || normalized === "PASS") className = styles.attemptStatusConfirmed;
    else if (normalized === "CANCELLED" || normalized === "DISQUALIFIED" || normalized === "FAIL")
        className = styles.attemptStatusCancelled;
    else if (normalized === "PENDING") className = styles.attemptStatusPending;

    return <span className={className}>{toStatusText(normalized)}</span>;
};

export const renderFlagBadge = (flagged) => {
    if (flagged === true) return <span className={styles.flagTrue}>{i18n.t("examStatus.flagSuspicious", {defaultValue: "Şübhəli"})}</span>;
    if (flagged === false) return <span className={styles.flagFalse}>{i18n.t("examStatus.flagNormal", {defaultValue: "Normal"})}</span>;
    return "-";
};
